const getDataVolume = (data) => {
  const { size } = new Blob([encodeURIComponent(JSON.stringify(data))]);

  return { size };
};

export default getDataVolume;
